export default __webpack_public_path__ + "static/media/Landing_Logo_UDEA.038a4ddb.png";